module.exports = __webpack_public_path__ + "static/patreon-light-f378deef1b198ec3c899716eaa277b7b.png";